module.exports = __webpack_public_path__ + "static/media/Сакиева А. (НУ).21c97ba7.pdf";